import { memo, useCallback } from "react";

import { Button } from "@react/components/Button";
import { getHeaderHeights } from "@tablescape/utilities";
import { tw } from "classnames";

type Anchor = {
  sectionHandle: string;
  sectionIndex?: number;
  text: string;
};

type Props = {
  anchors: Anchor[];
};
const styles = {
  base: tw("flex", "flex-col", "gap-y-4", "pt-8", "md:pt-9"),
  button: tw("w-fit"),
};

const AnchorButtonsViewBase = ({ anchors }: Props) => {
  const handleButtonClick = useCallback(
    (anchor: Anchor) => () => {
      const sectionElement = document.querySelectorAll<HTMLElement>(
        ".shopify-section" + `.section-${anchor.sectionHandle}`
      );

      const anchorSectionElement = sectionElement[anchor.sectionIndex ?? 0];
      if (!anchorSectionElement) {
        return;
      }

      anchorSectionElement.style.scrollMarginTop = `${getHeaderHeights()}px`;
      anchorSectionElement.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "start",
      });
    },
    []
  );

  return (
    <div className={styles.base}>
      {anchors.map((anchor) => (
        <Button
          className={styles.button}
          iconName="arrow-down"
          iconPosition="end"
          key={`anchorButton-${anchor.text}`}
          onClick={handleButtonClick(anchor)}
          type="quaternary"
        >
          {anchor.text}
        </Button>
      ))}
    </div>
  );
};

export const AnchorButtonsView = memo(AnchorButtonsViewBase);
